import { createContext, Dispatch, SetStateAction, useContext } from "react";

import {
  DEFAULT_ONBOARDING_VARIANT_ID,
  OnboardingConcernOptionEnum,
  OnboardingVariantIdType,
} from "@/domain/onboarding";
import { I18nKeyType } from "@/i18n";
import {
  buildOnboardingI18nKey,
  OnboardingI18nPathType,
} from "@/utils/onboarding";

type OnboardingContextType = {
  variantId: OnboardingVariantIdType;
  selectedConcernOption: OnboardingConcernOptionEnum | null;
  setSelectedConcernOption: Dispatch<
    SetStateAction<OnboardingConcernOptionEnum | null>
  >;
  getI18nKey: (path: OnboardingI18nPathType) => I18nKeyType | I18nKeyType[];
};

export const OnboardingContext = createContext<OnboardingContextType>({
  variantId: DEFAULT_ONBOARDING_VARIANT_ID,
  selectedConcernOption: null,
  setSelectedConcernOption: () => undefined,
  getI18nKey: path =>
    buildOnboardingI18nKey({ variantId: DEFAULT_ONBOARDING_VARIANT_ID, path }),
});

export const useOnboarding = () => useContext(OnboardingContext);
